import * as Yup from 'yup';

import { LanguageCode } from 'i18n/internationalization.types';
import { SystemTemplate } from 'models/automation/SystemTemplates';

const perLanguageSchema = () =>
  Yup.object({
    content: Yup.string().richTextEditorContentRequired(),
    content_htmlContent: Yup.string().required(),
    subject: Yup.string().required(),
  }).nullable();

export const systemTemplateEditModalSchema = ({
  availableLanguages,
}: {
  availableLanguages: LanguageCode[];
}) =>
  Yup.object({
    language: Yup.string().required(),
    sendCopyToAgency: Yup.boolean(),
    locales: Yup.object({
      ...availableLanguages.reduce(
        (acc, language) => ({
          ...acc,
          [language]: perLanguageSchema().optional(),
        }),
        {} as {
          [key in LanguageCode]: ReturnType<typeof perLanguageSchema>;
        },
      ),
    }),
  });

export type SystemTemplateEditModalFormValues = Yup.InferType<
  ReturnType<typeof systemTemplateEditModalSchema>
>;

export const getFormDefaultValues = ({
  currentLanguage,
  systemTemplate,
  availableLanguages,
}: {
  currentLanguage: LanguageCode;
  systemTemplate: SystemTemplate;
  availableLanguages: LanguageCode[];
}): SystemTemplateEditModalFormValues => {
  return {
    language: currentLanguage,
    sendCopyToAgency: systemTemplate.sendCopyToAgency ?? false,
    locales: availableLanguages.reduce((acc, language) => {
      const localeContents = systemTemplate.locales[language];

      return {
        ...acc,
        [language]: {
          content: localeContents?.content ?? '',
          content_htmlContent: localeContents?.content ?? '',
          subject: localeContents?.subject ?? '',
        },
      };
    }, {} as SystemTemplateEditModalFormValues['locales']),
  };
};
